import { app } from 'app/providers/FirebaseProvider/ui/FirebaseProvider'
import { getAuth } from 'firebase/auth'
import { loadLegacyFirestore } from 'shared/firebase/loadLegacyFirebase'
import { backendForFirebaseUser } from './backendForFirebaseUser'

export const searchProfileData = async (input) => {
    const normalizedInput = String(input).trim().replace(/^@/, '')
    if (!/^[A-Za-z0-9_]{1,30}$/.test(normalizedInput)) {
        throw new TypeError('Invalid profile search')
    }

    const backend = backendForFirebaseUser(getAuth(app).currentUser)
    if (backend) {
        const result = await backend.searchProfiles(normalizedInput)
        return result.profiles
    }

    const { collection, db, getDocs, query, where } =
        await loadLegacyFirestore()
    const numericInput = /^\d+$/.test(normalizedInput)
    const field = numericInput ? 'id' : 'nickname'
    const operator = numericInput ? '==' : '>='
    const value = numericInput ? Number(normalizedInput) : normalizedInput
    const snapshot = await getDocs(
        query(collection(db, 'Auth'), where(field, operator, value))
    )

    return snapshot.docs
        .map((document) => ({ ...document.data() }))
        .filter(
            (profile) =>
                profile.avatar &&
                (numericInput || profile.nickname?.includes(normalizedInput))
        )
}
